import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useUser } from '../components/auth/AuthPage/UserContext';

/**
 * Chat unread counts for the navbar badge: unread messages in your
 * chats (muted chats and message requests don't count) and the number
 * of waiting message requests. Polls while the tab is visible; the
 * Messages page calls refresh() after reading or sending.
 */
const MessagesContext = createContext({ unread: 0, requests: 0, refresh: () => { } });

export function MessagesProvider({ children }) {
    const { user } = useUser();
    const [counts, setCounts] = useState({ unread: 0, requests: 0 });

    const refresh = useCallback(() => {
        if (!user) { setCounts({ unread: 0, requests: 0 }); return; }
        fetch('/api/messages/unread', { credentials: 'include' })
            .then(r => (r.ok ? r.json() : null))
            .then(d => { if (d) setCounts({ unread: d.unread || 0, requests: d.requests || 0 }); })
            .catch(() => { });
    }, [user]);

    useEffect(() => {
        refresh();
        if (!user) return undefined;
        const id = setInterval(() => { if (!document.hidden) refresh(); }, 20000);
        window.addEventListener('focus', refresh);
        return () => {
            clearInterval(id);
            window.removeEventListener('focus', refresh);
        };
    }, [user, refresh]);

    return (
        <MessagesContext.Provider value={{ ...counts, refresh }}>
            {children}
        </MessagesContext.Provider>
    );
}

export const useMessages = () => useContext(MessagesContext);
